const getGlobal = () => {
  if (typeof window === "undefined") {
    return global;
  }
  return window ?? global ?? self;
};
export const Backbone = getGlobal()?.Backbone ?? {};
export const Diagram = getGlobal()?.Diagram ?? {};
export const EG = getGlobal()?.EG ?? {};
export const Hammer = getGlobal()?.Hammer ?? {};
export const Handlebars = getGlobal()?.Handlebars ?? {};
export const I18n = getGlobal()?.I18n ?? {};
export const Zepto = getGlobal()?.Zepto ?? {};
export const JQuery = getGlobal()?.jQuery ?? {};
export const Utils = getGlobal()?.uitk?.utils ?? {};
export const uitk = getGlobal()?.uitk ?? {};
